import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={22.926}
      strokeWidth={1.2}
      d="M10.937 17.483c.086-.35.117-.744.099-1.162m0 0c-.126-2.904-2.62-7.003-5.306-6.216-.682.2-1.25.699-1.583 1.394m6.889 4.822c-2.64-.612-5.316-2.189-6.89-4.822m6.89 4.822c2.075.48 4.127.365 5.602-.301M4.147 11.499c-.554 1.158-.453 2.86.875 4.63 1.68 2.239 4.984 3.98 7.37 3.866 2.233-.107 3.86-1.736 4.246-3.975M4.147 11.499a9.6 9.6 0 0 1-.909-2.022c-.958-3.017 1.03-5.692 4.97-4.35m8.43 10.893c.205-1.191.06-2.555-.534-3.954m.534 3.954c.642-.29 1.175-.685 1.554-1.181.682-.894.894-1.961.745-3.072m-2.833.3c-.936-2.21-2.987-4.507-6.53-6.35a10 10 0 0 0-1.366-.59m7.896 6.94c-1.2-.132-2.618-.575-4.278-1.518-3.205-1.822-4.154-4.09-3.618-5.422m7.896 6.94c1.128.122 2.065-.03 2.834-.3m-10.73-6.64c.312-.776 1.127-1.235 2.293-1.105 4.074.454 7.978 4.308 8.437 7.745m0 0c1.008-.354 1.724-.912 2.199-1.318"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={22.926}
      strokeWidth={1.2}
      d="M10.937 17.483c.688-2.783-2.134-8.279-5.207-7.378-1.818.533-2.833 3.193-.708 6.023 1.68 2.24 4.985 3.98 7.37 3.867"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const AnxietyIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
